import {ForYouItem} from '../shared/ForYouItem'
import {ChecksSection} from './shared/ChecksSection'
import {decideChecksItem} from './shared/checks-item-decider'
import {useValidatedChecksData} from './use-validated-checks-data'
import {StatusCheckStatesIcon} from '@github-ui/mergebox/components/sections/checks/StatusCheckStatesIcon'
import {
  accessibleChecksSummary,
  checksSectionHeading,
} from '@github-ui/mergebox/components/sections/checks/checks-section-header-text'
import styles from './CompletedChecks.module.css'

// Renders when all checks have reached a terminal state
export function CompletedChecks() {
  const data = useValidatedChecksData()

  if (!data || decideChecksItem(data).kind !== 'completed') {
    return null
  }

  const {mergeBoxPullRequest, statusChecks, statusRollup, checksSection} = data
  const heading = checksSectionHeading[checksSection.sectionStatus]
  const summary = accessibleChecksSummary(statusRollup.summary)

  return (
    <ForYouItem
      leadingVisual={<StatusCheckStatesIcon statusRollupSummary={statusRollup.summary} size={16} />}
      title={
        <>
          <span className={styles.heading}>{heading}</span>
          <span aria-hidden="true" className={styles.middot}>
            ·
          </span>
          <span className={styles.summary}>{summary}</span>
        </>
      }
      ariaLabel={`${heading}, ${summary}`}
      itemName="completed-checks"
      padding="none"
    >
      <ChecksSection
        statusChecks={statusChecks}
        mergeBoxPullRequest={mergeBoxPullRequest}
        statusRollup={statusRollup}
      />
    </ForYouItem>
  )
}
